import {
  ADMIN_TOKEN_KEY,
  LEGACY_ADMIN_TOKEN_KEY,
  TOKEN_EXPIRATION_TIME,
} from '../constants/auth';

const TokenService = {
  // Set the token in local storage with expiration
  setToken: (token) => {
    try {
      const tokenData = {
        token,
        expiration: Date.now() + TOKEN_EXPIRATION_TIME,
      };
      localStorage.setItem(ADMIN_TOKEN_KEY, JSON.stringify(tokenData));
    } catch (error) {
      console.warn('localStorage is not available:', error);
    }
  },

  // Get the token from local storage and check expiration
  getToken: () => {
    try {
      // Check for legacy token and migrate if exists
      const legacyToken = localStorage.getItem(LEGACY_ADMIN_TOKEN_KEY);
      if (legacyToken) {
        localStorage.removeItem(LEGACY_ADMIN_TOKEN_KEY);
      }

      const tokenData = localStorage.getItem(ADMIN_TOKEN_KEY);
      if (!tokenData) return null;

      // Ensure tokenData is a valid JSON string
      const parsedData = JSON.parse(tokenData);
      if (!parsedData || typeof parsedData !== 'object') {
        console.warn(
          'Invalid token data format. Clearing token and redirecting to login.'
        );
        TokenService.clearToken();
        TokenService.redirectToLogin();
        return null;
      }

      const { token, expiration } = parsedData;

      // Check if token is expired
      if (Date.now() > expiration) {
        console.warn(
          'Token has expired. Clearing token and redirecting to login.'
        );
        TokenService.clearToken();
        TokenService.redirectToLogin();
        return null;
      }

      return token;
    } catch (error) {
      console.error('Error retrieving token:', error);
      TokenService.clearToken();
      TokenService.redirectToLogin();
      return null;
    }
  },

  // Clear the token from local storage
  clearToken: () => {
    try {
      localStorage.removeItem(ADMIN_TOKEN_KEY);
    } catch (error) {
      console.warn('Error clearing token:', error);
    }
  },

  // Redirect to login page
  redirectToLogin: () => {
    TokenService.clearToken();
    const baseUrl = window.location.origin; // Dynamically get the base URL
    window.location.href = `${baseUrl}/auth/login`;
  },

  // Check if token is valid
  isTokenValid: () => {
    return !!TokenService.getToken();
  },
};

export default TokenService;
